import { createUseStyles } from "react-jss";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useStyles = createUseStyles(() => ({
  formHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  deleteIcon: {
    color: "rgba(0, 0, 0) !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
}));
